import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { BasePage } from 'src/app/lib/base-page';
import { LoginService } from 'src/app/services/login.service';
import { MobilityService } from 'src/app/services/mobility.service';
import { SubscriptionService } from 'src/app/services/subscription.service';


@Component({
  selector: 'app-mobility-intro',
  templateUrl: './mobility-intro.page.html',
  styleUrls: ['./mobility-intro.page.scss'],
})
export class MobilityIntroPage extends BasePage implements OnInit {
  email: string = ''

  constructor(private router: Router,
    private loginService: LoginService,
    private subscription: SubscriptionService,
    private mobilityService: MobilityService,
  ) {
    super();
  }

  ngOnInit() {
    this.loginService.profile().subscribe(res => {
      this.email = res.data.email
    })
  }

  goToMobility() {
    localStorage.setItem('MobilityIntro-' + this.email, '');
    this.loginService.profile()
      .subscribe(async resLog => {
        this.mobilityService.checkCouponCode().subscribe(res => {
          if (this.subscription.subscription(resLog.data) || res.message.status === 'success') {
            this.router.navigateByUrl('/mobility');
          } else {
            this.router.navigateByUrl('/mobility/payment-intro');
          }
        })

      });
  }
}
